import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectActors, selectSelectedElement } from "../../../app/slices/TrainingSlice";
import { Actor } from "../../../models/Actor";
import { IConversation } from "../../../models/interactions/Conversation";
import PiPopupWindowPreview from "../components/PiPopupWindowPreview";
import PiPopupHeaderBar from "../components/PiPopupHeaderBar";
import { InteractionType } from "../../../models/interactions/Interaction";
import ConversationPreviewBody from "./ConversationPreviewBody";
import { PiAvatarProfileGroup } from "./PiAvatarProfileGroup";

export default function ConversationPreview() {
  //Only use actors present in the conversation preview
  const allActors: Actor[] = useSelector(selectActors);
  const conversationActorIds: string[] = [...new Set(((useSelector(selectSelectedElement) as IConversation).messages).map(message => message.npcId))];
  const conversationActors: Actor[] = allActors.filter(actor => conversationActorIds.includes(actor.id));
  const { t } = useTranslation();

  const body = <ConversationPreviewBody />;

  return (
    <PiPopupWindowPreview
      header={
        <PiPopupHeaderBar
          interactionType={InteractionType.Conversation}
          title={String(t("conversation"))}
          trailing={<PiAvatarProfileGroup actors={conversationActors} maxActorsShown={3} />}
        />
      }
      body={body}
    />
  );
}
